<template lang="pug">
div.mylist--profile(v-show="firstLoaded" :data-showing="displayMode")

  template(v-if="isMypage")
    create-or-edit-form(v-model="myListForForm" :visibleMyListForm="visibleMyListForm" @hide-my-list-form="$emit('hide-my-list-form')" @on-submit-form="submitForm" @destroy-my-list="destroyMyList")
    div.mylist--explain(v-show="myLists.length == 0")
      button.mylist--explain-new(@click="showEditMyListForm(0)")
        i.font-awesome-icon(class="fa fa-folder-plus")
        | マイリストを作成
      p.mylist--explain-text
        | 自分専用のリストを作ることができます。マイボードゲーム機能や、ゲームデータに登録されているタグ情報と異なり、マイリストは公開/非公開を設定することができます。
      p.mylist--explain-text
        | 『いつもボドゲ会に持っていく作品』
        | 『積みゲー（買ったけど遊んでない）』
      p.mylist--explain-text
        | といった自分用のマイリストを作成したり、
      p.mylist--explain-text
        | 『入手しやすいおすすめトリックテイキング』
        | 『重ゲーに慣れていくためのボドゲ10選』
        | 『初対面の相手とも打ち解けるならコレ！』
      p.mylist--explain-text
        | など、自由にテーマを決めてリストをまとめていただくことも歓迎しています。リスト作成後はSNSボタンから、ぜひ周囲の方にシェアしてみてください。
  template(v-else)
    p.mylist--empty(v-show="myLists.length == 0")
      | マイリストが未登録または<br>すべて非公開に設定されています。

  div.mylist--selector(v-show="myLists.length != 0")
    button.mylist--selector-new(v-if="isMypage" @click="showEditMyListForm(0)")
      i.font-awesome-icon(class="fa fa-folder-plus")
      | 新しいマイリスト
    div.mylist--selector-list
      div.mylist--selector-item(@click="setMyListId(myList.id)" v-for="myList in myLists" :key="myList.id" :class="myList.published ? 'public' : 'private'" :data-selecting="myList.id === showMyListId")
        div.mylist--selector-icon(v-if="!myList.published")
          i.fa.font-awesome-icon.fa-lock
        div.mylist--selector-name
          | {{myList.name}}
        div.mylist--selector-count
          | {{myList.size}}
    infinite-loading(spinner="waveDots" @infinite="infiniteHandlerForIndex" :identifier="infiniteIdForIndex" ref="infiniteLoadingForIndex")
      span(slot="no-results")
      span(slot="no-more")
    button.mylist--selector-history(@click="viewHistoryPage")
      | マイリストの変更履歴

  my-list-related-history-index(v-show="myLists.length != 0" :friendId="friendId" :myListRelatedHistories="myListRelatedHistories" @set-my-list-id="setMyListId" @view-index-my-list-page="viewIndexMyListPage" @index-my-list-related-history="$listeners['index-my-list-related-history']" ref="myListRelatedHistoryIndex")

  div.mylist--games(v-show="showMyList.id")
    div.mylist--games-title
      div.mylist--games-icon(v-if="!showMyList.published")
        i.fa.font-awesome-icon.fa-lock
      h2.mylist--games-label
        | {{showMyList.name}}
      var.mylist--games-count
        | {{showMyList.size}}
    p.mylist--games-description {{showMyList.description}}
    template(v-if="isMypage")
      div.mylist--games-edit
        button.mylist--games-add(@click="showSearchForm")
          i.font-awesome-icon(class="fa fa-plus")
          | ボードゲームを追加
        button.mylist--games-public(@click="showEditMyListForm(showMyList)")
          i.font-awesome-icon(class="fa fa-cog")
          | 設定を編集する
        search-games-form(:visibleSearchForm="visibleSearchForm" :myListId="showMyList.id" @hide-search-form="hideSearchForm" @change-my-list-size="$listeners['change-my-list-size']")

    template(v-if="myListElementsForDraggable.length == 0")
      div.mylist--games-empty
        | 登録されているボードゲームがありません
    template(v-else)
      draggable(tag="div" v-model="myListElementsForDraggable" class="mylist--games-list" handle=".element--handle" :data-dragging="dragging" animation="300" @start="onDragStart" @end="onDragEnd")
        div.mylist--games-item(v-for="myListElement in myListElementsForDraggable" :key="myListElement.id" :data-editing="myListElement.id == editMyListElement.id && visibleEditMyListElementForm")
          button.mylist--games-sort.element--handle(v-if="isMypage" title="ドラッグで並び順変更")
            i.font-awesome-icon(class="fa fa-sort")
          img.mylist--games-picture(:src="myListElement.picture" :alt="myListElement.name" :width="100" :height="75")
          div.mylist--games-data
            div.mylist--games-showing
              p.mylist--games-spec
                span.mylist--games-players(v-show="myListElement.players_range_text")
                  i.font-awesome-icon(class="fa fa-users")
                  | {{myListElement.players_range_text}}
                span.mylist--games-playtime(v-show="myListElement.playtime_range_text")
                  i.font-awesome-icon(class="fa fa-clock-o")
                  | {{myListElement.playtime_range_text}}
                //- span.mylist--games-published(v-show="myListElement.decorated_publication_date")
                //-   i.font-awesome-icon(class="fa fa-calendar")
                //-   | {{myListElement.decorated_publication_date}}
              a.mylist--games-name(:href="myListElement.path" target="_blank")
                | {{myListElement.name}}
              p.mylist--games-commented(v-if="myListElement.comment")
                i.font-awesome-icon(class="fa fa-comment")
                template(v-for="text in myListElement.comment.split('\\n')")
                  | {{text}}
                  br
              div.mylist--games-action(v-if="isMypage")
                button.mylist--games-comment(v-if="isMypage" @click="showEditMyListElementForm(myListElement.id)")
                  i.font-awesome-icon(class="fa fa-pencil")
                  | コメント/メモ
                button.mylist--games-remove(@click="destroyMyListElement(myListElement.id)")
                  i.font-awesome-icon(class="fa fa-close")
                  | リストから外す
            div.mylist--games-editing
              textarea-autosize.mylist--games-textarea(v-model="editMyListElement.comment" :max-height="89" maxlength="200" placeholder="コメント/メモを記入")
              div.mylist--games-submit
                button.mylist--games-save.btn(@click="updateMyListElement")
                  | 登録する
                button.mylist--games-cancel.btn(@click="hideMyListElementForm")
                  i.font-awesome-icon(class="fa fa-close")

      p.mylist--games-sortable(v-if="isMypage")
        i.font-awesome-icon(class="fa fa-sort")
        | をドラッグして並び替えることが出来ます。

    button.mylist--games-back(@click="viewIndexMyListPage")
      i.font-awesome-icon(class="fa fa-angle-left")
      | 一覧に戻る


    infinite-loading(spinner="waveDots" @infinite="infiniteHandlerForShow" :identifier="infiniteIdForShow" ref="infiniteLoadingForShow" v-show="showMyList.id")
      span(slot="no-results")
      span(slot="no-more")
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import CreateOrEditForm from 'components/my_lists/create_or_edit_form.vue';
import MyListRelatedHistoryIndex from 'components/my_lists/my_list_related_history_index.vue';
import SearchGamesForm from 'components/my_lists/search_games_form.vue';
import Draggable from 'vuedraggable';

export default {
  components: { InfiniteLoading, CreateOrEditForm, MyListRelatedHistoryIndex, SearchGamesForm, Draggable },
  props: {
    showMyList: {
      type: Object,
      default: () => ({
        id: 0
      })
    },
    myLists: {
      type: Array,
      default: () => ([])
    },
    myListElements: {
      type: Array,
      default: () => ([])
    },
    myListRelatedHistories: {
      type: Array,
      default: () => ([])
    },
    infiniteIdForIndex: {
      type: Number,
      default: 0
    },
    infiniteIdForShow: {
      type: Number,
      default: 0
    },
    infiniteIdForHistory: {
      type: Number,
      default: 0
    },
    indexMyListPath: {
      type: String,
      default: null
    },
    showMyListIdFromParent: {
      type: Number,
      default: 0
    },
    isMypage: {
      type: Boolean,
      default: false
    },
    visibleMyListForm: {
      type: Boolean,
      default: false
    },
    visibleEditMyListElementForm: {
      type: Boolean,
      default: false
    },
    firstLoaded: {
      type: Boolean,
      default: false
    },
    friendId: {
      type: Number,
      default: 0
    },
  },
  data: function() {
    return {
      showMyListId: 0,
      myListForForm: {
        id: null,
        name: '',
        description: '',
        published: 1
      },
      editMyListElement: {
        id: 0,
        comment: ''
      },
      displayMode: '',
      dragging: false,
      visibleSearchForm: false
    };
  },
  computed: {
    myListElementsForDraggable: {
      get: function () {
        return [...this.myListElements];
      },
      set: function (myListElements) {
        this.$emit('set-my-list-elements', myListElements);
      }
    },
  },
  watch: {
    showMyListId: async function() {
      this.$emit('reset-show-page');
      if(this.showMyListId) {
        let showMyListPath = `${this.indexMyListPath}/${this.showMyListId}`;
        history.replaceState(null, null, showMyListPath);
        this.$emit('show-my-list', this.$refs.infiniteLoadingForShow.stateChanger, this.showMyListId);
        this.displayMode = 'games';
      } else {
        history.replaceState(null, null, this.indexMyListPath);
      }
    },
  },
  mounted: function() {
    this.showMyListId = this.showMyListIdFromParent;
  },
  methods: {
    infiniteHandlerForIndex: function($state) {
      this.$emit('index-my-list', $state);
    },
    infiniteHandlerForShow: function($state) {
      if (!this.showMyListId) {
        $state.complete();
      } else {
        this.$emit('show-my-list', $state, this.showMyListId);
      }
    },
    setMyListId: function(myListId) {
      this.showMyListId = myListId;
    },
    destroyMyList: function(myListId) {
      this.$emit('destroy-my-list', myListId);
    },
    updateMyListElement: function() {
      this.$emit('update-my-list-element', this.editMyListElement, this.showMyListId);
    },
    destroyMyListElement: function(myListElementId) {
      this.$emit('destroy-my-list-element', this.showMyListId, myListElementId);
    },
    updateOrderMyListElements: function() {
      this.$emit('update-order-my-list-elements', this.showMyListId);
    },
    showEditMyListForm: function(myList) {
      this.myListForForm = myList ? {...myList} : { id: null, name: '', description: '', published: 1 };
      this.$emit('show-my-list-form');
    },
    showEditMyListElementForm: function(myListElementId) {
      let myListElement = this.myListElements.find((myListElement) => myListElement.id == myListElementId);
      this.editMyListElement = {...myListElement};
      this.$emit('show-edit-my-list-element-form');
    },
    hideMyListElementForm: function() {
      this.$emit('hide-edit-my-list-element-form');
    },
    submitForm: function() {
      if (this.myListForForm.id) {
        this.$emit('update-my-list', this.myListForForm);
      } else {
        this.$emit('create-my-list', this.myListForForm);
      }
    },
    viewHistoryPage: function() {
      this.$emit('reset-history-page');
      this.$emit('index-my-list-related-history', this.$refs.myListRelatedHistoryIndex.$refs.infiniteLoading.stateChanger);
      this.setMyListId(0);
      this.displayMode = 'history';
    },
    viewIndexMyListPage: function() {
      this.setMyListId(0);
      this.displayMode = '';
    },
    onDragStart: function() {
      this.dragging = true;
    },
    onDragEnd: function() {
      this.dragging = false;
      this.updateOrderMyListElements();
    },
    showSearchForm: function() {
      this.visibleSearchForm = true;
    },
    hideSearchForm: function(needInitializeShowPage) {
      this.visibleSearchForm = false;
      this.onHideSearchForm(needInitializeShowPage);
    },
    onHideSearchForm: function(needInitializeShowPage) {
      if (needInitializeShowPage) {
        this.$emit('reset-show-page');
        this.$emit('show-my-list', this.$refs.infiniteLoadingForShow.stateChanger, this.showMyListId);
      }
    }
  }
};
</script>
